// extracted by mini-css-extract-plugin
export var list = "ArticleList-module--list--K6IJM";
export var iconCircle = "ArticleList-module--iconCircle--31W-B";